export class StudyModelRequest {
    "userId":Number;
    "otherId":Number;
   "message":String;
}